import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_WORK_ORDER_URL } from '../../connection.data';
import { BasicService } from './basic.service';

/**
 * Consulta y mantiene las órdenes de trabajo.
 *
 * La API es la fuente de verdad y aplica el aislamiento por empresa. Este
 * servicio encapsula las rutas CRUD definidas por `BasicService`.
 */
@Injectable()
export class WorkOrderService extends BasicService {
    constructor(http: HttpClient) {
        super(http);
        this.baseUrl = API_WORK_ORDER_URL;
    }
}
